import {t} from '@lingui/core/macro';
import {createAsyncThunk} from '@reduxjs/toolkit';

import {ApiUrls} from 'shared/config/model/urls';
import createHttpRequest from 'shared/api/http';
import {setTokens} from 'shared/api/auth';

import IRegistrationForm from '../forms/IRegistrationForm';

export const registerUser = createAsyncThunk<void, IRegistrationForm>(
    'auth/registerUser',
    async(userData) => {
        const tokens = await createHttpRequest({
            method: 'POST',
            path: ApiUrls.USERS(),
            data: userData,
            isAnonymous: true,
            errorMessage: t`При регистрации произошла ошибка! Попробуйте ещё раз.`,
        });

        setTokens(tokens.data);
    },
);
